import type { Tokens } from '../../../theming/types'
import type { InputDescriptionProps } from '..'

export default (config: {
  props: Pick<InputDescriptionProps, 'kind'>
  tokens: Tokens
}) => {
  const { tokens, props } = config
  return {
    default: {
      wrap: {
        ...tokens.fontDetailS,
        alignItems: props.kind === 'error' ? 'center' : undefined,
        display: props.kind === 'error' ? 'flex' : undefined,
        margin: 0,
        padding: 0,

        '& > svg': {
          alignSelf: props.kind === 'error' ? 'flex-start' : undefined,
          flex: props.kind === 'error' ? '0 0 auto' : undefined,
          marginInlineEnd: tokens.spacingGap50,
        },
      },
    },

    helper: {
      wrap: {
        color: tokens.fontColorSubtle,
      },
    },

    error: {
      wrap: {
        color: tokens.fontColorError,
        wordBreak: 'break-word',
      },
    },

    disabled: {
      cursor: 'not-allowed',
      opacity: tokens.opacityDisabled,
    },
  } as const
}
